import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { requests } from '.'

type Entity = {
  entityType: 'COMPANY' | 'LOCATION'
  entityId: string
}

// Configure request setup
const serviceName = 'InternalToolsService'
const host = servicesConfig.InternalTools
const opts: CustomAxiosHeaders = { host, serviceName, useNewToken: true }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const InternalToolsService = {
  updateLead: (body: any) => 
    request().put('/firstpromoter/lead', body).then(responseBody),

  removePromoterForCompany: (companyId: string) => 
    request().post(`/firstpromoter/${companyId}/remove-promoter`, {}).then(responseBody),

  createPaymentIntent: (body: any) => 
    request().post(`/billing/payment-intent`, body).then(responseBody),

  getDowngradableAgencyPlan: (companyId: string) => 
    request().get(`/billing/agency-plan/${companyId}/downgradable-plan`).then(responseBody),

  downgradeAgencyPlan: (body: any) => 
    request().post('/billing/agency-plan/downgrade', body).then(responseBody),

  defaultPaymentMethod: (params: Entity) =>
    request().get('/billing/payment-method', { params: { ...params, defaultOnly: true } }).then(responseBody),

  getHipaaDetails: (companyId: string) => 
    request().get(`/compliance/get-hipaa-detail/${companyId}`).then(responseBody),

  searchPartners: (filter: any) => 
    request().post(`/partners/search`, filter).then(responseBody),

  addOrUpdatePartner: (payload: any) => 
    request().post('/partners/update', payload).then(responseBody),

  deletePartner: (partnerId: string) => 
    request().delete(`/partners/${partnerId}`).then(responseBody),

  addPartnerContact: (payload: any) => 
    request().post('/partners/add-contact', payload).then(responseBody),

  sendEmail: (payload: any) => 
    request().post('/partners/email', payload).then(responseBody),

  getStripeCustomer: (params: Entity) => 
    request().get('/billing/customer', { params }).then(responseBody),

  addCard: (payload: any) => 
    request().post('/billing/payment-method/card', payload).then(responseBody),

  getCompanyBillingInfo: (companyId: string) => 
    request().get(`/billing/company-info/${companyId}`).then(responseBody),

  checkOverused: (companyId: string) => 
    request().post(`/billing/company/${companyId}/check-overused`, {}).then(responseBody),

  locationTransferRequest: (body: any) => 
    request().post('/location-transfers', body).then(responseBody),

  ejectLocationRequest: (body: any) => 
    request().post('/location-transfers/eject', body).then(responseBody),

  fetchEjectRequests: (params: any) => 
    request().get('/location-transfers/eject', { params }).then(responseBody),

  locationTransferRequestsFetch: (params: any) => 
    request().get(`/location-transfers/requests`, { params }).then(responseBody),

  getOfferDetails: (params: any) => 
    request().get(`/billing/offers/custom-offers`, { params }).then(responseBody),

  getCompanyBillingPlan: (companyId: string) => 
    request().get(`/billing/company/${companyId}/plan`).then(responseBody),

  retrieveOffers: (companyId: string, offerUrl: string) =>
    request().get(`/billing/offers/custom-offers/${companyId}?offerUrl=${offerUrl}`).then(responseBody),

  implementationCountCheck: (userId: string) => 
    request().get(`/billing/implementation-modal-count?userId=${userId}`).then(responseBody),

  implementationCountUpdate: (userId: string) => 
    request().post(`/billing/implementation-modal-count`, { userId }).then(responseBody),

  fetchActiveAddOns:(companyId: string) => 
    request().get(`/billing/company/${companyId}/addons`).then(responseBody),

  fetchPremiumSupport: (companyId: string) => 
    request().get(`/premium-support`, { params: { companyId } }).then(responseBody)
}

export default InternalToolsService
